import * as React from 'react';
import classnames from 'classnames';
import { IMantleRichText } from '~domain/entities/Node';

interface IRichText extends IMantleRichText {
    className?: string;
}

export const MantleRichText = (props: IRichText) => {
    const { font_classes, html, className } = props;

    const classNames = classnames('elc-rich-text', 'js-rich-text', 'custom-text', font_classes);

    return html ? (
        <div className={classnames(className)}>
            <div className={classNames} dangerouslySetInnerHTML={{ __html: html }} />
        </div>
    ) : null;
};
